const e=(e,t,n)=>i=>{t((t=>({...t,refinementList:{...t.refinementList,[e]:i}}))),n?.(e,i)};export{e as handleSliderOnChange};
